/* =========================================================
   ESTILO PAULA — Theme JS
   ========================================================= */
(function () {
  "use strict";

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Mobile nav ---------- */
  var mobileNav = qs("[data-mobile-nav]");
  qsa("[data-mobile-nav-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (mobileNav) mobileNav.setAttribute("data-open", "true");
      document.body.style.overflow = "hidden";
    });
  });
  qsa("[data-mobile-nav-close]").forEach(function (btn) {
    btn.addEventListener("click", closeMobileNav);
  });
  function closeMobileNav() {
    if (mobileNav) mobileNav.setAttribute("data-open", "false");
    document.body.style.overflow = "";
  }

  /* ---------- Cart Drawer ---------- */
  var cartDrawer = qs("[data-cart-drawer]");

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute("data-open", "true");
    document.body.style.overflow = "hidden";
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute("data-open", "false");
    document.body.style.overflow = "";
  }
  qsa("[data-cart-drawer-open]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });
  qsa("[data-cart-drawer-close]").forEach(function (el) {
    el.addEventListener("click", closeCartDrawer);
  });

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var currency = (window.themeSettings && window.themeSettings.moneyFormat) || "$";
    return currency + parts[0];
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer) return;
    var itemsWrap = qs("[data-cart-items]", cartDrawer);
    var emptyWrap = qs("[data-cart-empty]", cartDrawer);
    var footer = qs("[data-cart-footer]", cartDrawer);
    var countEls = qsa("[data-cart-count]");
    var subtotalEl = qs("[data-cart-subtotal]", cartDrawer);
    var freeShipWrap = qs("[data-free-shipping]", cartDrawer);

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (cart.item_count === 0) {
      if (itemsWrap) itemsWrap.innerHTML = "";
      if (emptyWrap) emptyWrap.style.display = "block";
      if (footer) footer.style.display = "none";
      return;
    }
    if (emptyWrap) emptyWrap.style.display = "none";
    if (footer) footer.style.display = "block";

    if (itemsWrap) {
      itemsWrap.innerHTML = cart.items
        .map(function (item, index) {
          var img = item.image
            ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, "&quot;") + '" loading="lazy">'
            : "";
          return (
            '<div class="cart-line" data-line-index="' + (index + 1) + '">' +
              '<a href="' + item.url + '" class="cart-line__media">' + img + "</a>" +
              '<div class="cart-line__body">' +
                '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + "</a>" +
                (item.variant_title ? '<div class="cart-line__variant">' + item.variant_title + "</div>" : "") +
                '<div class="qty-selector" data-qty-selector>' +
                  '<button type="button" data-qty-decrease aria-label="Restar cantidad">&minus;</button>' +
                  '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-input readonly>' +
                  '<button type="button" data-qty-increase aria-label="Sumar cantidad">&plus;</button>' +
                "</div>" +
              "</div>" +
              '<div class="cart-line__right">' +
                '<div class="cart-line__price">' + formatMoney(item.final_line_price) + "</div>" +
                '<button type="button" class="cart-line__remove" data-qty-remove>Eliminar</button>' +
              "</div>" +
            "</div>"
          );
        })
        .join("");
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (freeShipWrap) {
      var threshold = parseInt(freeShipWrap.getAttribute("data-threshold") || "0", 10);
      var fill = qs("[data-free-shipping-fill]", freeShipWrap);
      var msg = qs("[data-free-shipping-msg]", freeShipWrap);
      if (threshold > 0) {
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        if (fill) fill.style.width = pct + "%";
        if (msg) {
          if (cart.total_price >= threshold) {
            msg.innerHTML = "¡Felicidades! Tienes <strong>envío gratis</strong> \u2764";
          } else {
            msg.innerHTML =
              "Te faltan <strong>" + formatMoney(threshold - cart.total_price) + "</strong> para envío gratis";
          }
        }
      }
    }

    bindQtyEvents();
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); });
  }

  function refreshCart() {
    fetchCart().then(renderCartDrawer);
  }

  function bindQtyEvents() {
    qsa("[data-qty-selector]").forEach(function (wrap) {
      var line = wrap.closest("[data-line-index]");
      if (!line || line.dataset.bound) return;
      line.dataset.bound = "true";
      var index = line.getAttribute("data-line-index");
      var input = qs("[data-qty-input]", wrap);

      qs("[data-qty-increase]", wrap).addEventListener("click", function () {
        updateLine(index, parseInt(input.value, 10) + 1);
      });
      qs("[data-qty-decrease]", wrap).addEventListener("click", function () {
        updateLine(index, Math.max(0, parseInt(input.value, 10) - 1));
      });
      var removeBtn = qs("[data-qty-remove]", line);
      if (removeBtn) {
        removeBtn.addEventListener("click", function () { updateLine(index, 0); });
      }
    });
  }

  function updateLine(index, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: index, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer);
  }

  /* Intercept product-add-to-cart forms for AJAX add */
  qsa("form[data-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var submitBtn = qs("[type=submit]", form);
      var formData = new FormData(form);

      if (submitBtn) {
        submitBtn.setAttribute("disabled", "disabled");
        submitBtn.dataset.originalText = submitBtn.innerHTML;
        submitBtn.innerHTML = '<span class="spinner" aria-hidden="true"></span> Agregando…';
      }

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            // Shopify error shape
            var errBox = qs("[data-product-form-error]", form);
            if (errBox) {
              errBox.textContent = res.description || "No se pudo agregar el producto.";
              errBox.style.display = "block";
            }
          } else {
            refreshCart();
            openCartDrawer();
          }
        })
        .catch(function () {})
        .finally(function () {
          if (submitBtn) {
            submitBtn.removeAttribute("disabled");
            submitBtn.innerHTML = submitBtn.dataset.originalText;
          }
        });
    });
  });

  refreshCart();

  /* ---------- Product gallery thumbnails ---------- */
  qsa("[data-gallery]").forEach(function (gallery) {
    var main = qs("[data-gallery-main]", gallery);
    qsa("[data-gallery-thumb]", gallery).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        if (main && full) main.src = full;
        qsa("[data-gallery-thumb]", gallery).forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  });

  /* ---------- Product variant swatches (visual only, form still controls real select) ---------- */
  qsa("[data-swatch-group]").forEach(function (group) {
    var select = qs("select", group.closest("[data-product-form]") || document);
    qsa("[data-swatch]", group).forEach(function (btn) {
      btn.addEventListener("click", function () {
        qsa("[data-swatch]", group).forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        var hiddenInput = group.closest("[data-product-form]")
          ? qs('input[name="' + group.getAttribute("data-option-name") + '"]', group.closest("[data-product-form]"))
          : null;
        if (hiddenInput) hiddenInput.value = btn.getAttribute("data-value");
        group.dispatchEvent(new CustomEvent("swatch:change", { bubbles: true, detail: { value: btn.getAttribute("data-value") } }));
      });
    });
  });

  /* ---------- Accordion (product details) ---------- */
  qsa("[data-accordion-trigger]").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var item = trigger.closest("[data-accordion-item]");
      if (!item) return;
      var wasOpen = item.classList.contains("is-open");
      item.parentElement.querySelectorAll("[data-accordion-item]").forEach(function (i) {
        i.classList.remove("is-open");
      });
      if (!wasOpen) item.classList.add("is-open");
    });
  });

  /* ---------- Simple quantity stepper (product page, non-cart) ---------- */
  qsa("[data-simple-qty]").forEach(function (wrap) {
    var input = qs("input", wrap);
    qs("[data-qty-increase]", wrap).addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + 1);
    });
    qs("[data-qty-decrease]", wrap).addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    qsa(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    qsa(".reveal").forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- Newsletter / contact forms: basic feedback ---------- */
  qsa("[data-ajax-form]").forEach(function (form) {
    form.addEventListener("submit", function () {
      var btn = qs("[type=submit]", form);
      if (btn) btn.setAttribute("disabled", "disabled");
    });
  });
})();
